export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const SET_PAGE_TITLE = 'set-page-title';
export const SET_ALERT_DATA = 'set-alert-data';
export const UPDATE_ALERT_STATUS = 'update-alert-status';
export const UPDATE_DISCHARGE_DATE = 'update-discharge-date';
export const CHANGE_APPOINTMENT_DATE = 'change-appointment-date';
export const UPDATE_ALERT_STATUS_AND_APPOINTMENT =
  'update-alert-status-and-appointment';
export const SET_CHART_DATA = 'set-chart-data';
export const SET_CHART_DATA_FETCHED = 'set-chart-data-fetched';
export const UPDATE_ACCESS_TOKEN = 'update-access-token';
